import { render, staticRenderFns } from "./KPanelRow.vue?vue&type=template&id=539da5bb&"
import script from "./KPanelRow.vue?vue&type=script&lang=js&"
export * from "./KPanelRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports